import UpArrow from "../icons/upArrow";
import Link from "@components/shared/linkNoPrefetch";
import { GQLPosts } from "@gql/types/gql";
import Image from "next/legacy/image";

export default function ListOfLinks({
    title,
    items,
}: {
    title: string;
    items: GQLPosts[];
}) {
    return (
        <>
            <h2 className=" mt-10 lg:mb-4 mb-2 lg:text-3xl text-xl leading-10 font-extrabold lg:leading-[60px]">
                {title}
            </h2>
            <div className="flex flex-col gap-10">
                {items?.map((blog, index) => (
                    <Link
                        key={index}
                        href={
                            //@ts-ignore
                            (blog?.url?.url as string) ?? (blog?.link as string)
                        }
                        className={`flex justify-between items-center cursor-pointer text-black gap-4`}
                    >
                        {blog.image && blog.image.fullPath && (
                            <Image
                                src={blog.image?.fullPath}
                                alt={blog.title as string}
                                width={207}
                                height={142}
                                itemProp="image"
                                className={`relative block w-[300px]`}
                            />
                        )}
                        <div className="w-full font-bold lg:text-xl text-sm">
                            {blog.title}
                        </div>
                        <span className="rotate-90">{<UpArrow />}</span>
                    </Link>
                ))}
            </div>
        </>
    );
}
